var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List, ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction, IconButton } from "@mui/material";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import DeleteIcon from '@mui/icons-material/Delete';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
export default function WorkflowStepsList(props) {
    // a little function to help us with reordering the result
    var reorder = function (list, startIndex, endIndex) {
        var result = Array.from(list);
        var removed = result.splice(startIndex, 1)[0];
        result.splice(endIndex, 0, removed);
        return result;
    };
    var getItemStyle = function (index, isDragging, draggableStyle) { return (__assign(__assign(__assign(__assign({}, draggableStyle), { padding: "5px", cursor: "pointer" }), (isDragging && {
        background: "rgb(235,235,235)"
    })), (index === props.selectedStepIndex && {
        background: "#cae9f5"
    }))); };
    var onDragEnd = function (result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        var reordered = reorder(__spreadArray([], props.steps, true), result.source.index, result.destination.index).map(function (s, i) { return __assign(__assign({}, s), { order: i + 1 }); });
        props.onStepsReordered(reordered, result.destination.index);
    };
    function renderActions(index, isDraggingOver, dragHandleProps, disabled) {
        if (disabled)
            return null;
        return (_jsxs("div", { children: [_jsx(IconButton, __assign({}, dragHandleProps, { children: _jsx(UnfoldMoreIcon, {}, void 0) }), void 0), isDraggingOver ? null :
                    _jsx(IconButton, __assign({ onClick: function () { return props.onStepDeleteClick(index); } }, { children: _jsx(DeleteIcon, {}, void 0) }), void 0)] }, void 0));
    }
    return (_jsx(DragDropContext, __assign({ onDragEnd: onDragEnd }, { children: _jsx(Droppable, __assign({ droppableId: "droppable", isDropDisabled: props.disabled }, { children: function (provided, snapshot) { return (_jsxs(List, __assign({ ref: provided.innerRef, disablePadding: true, style: { flex: "1", border: "1px solid #ccc", overflow: "auto" } }, { children: [props.steps.map(function (item, index) { return (_jsx(Draggable, __assign({ draggableId: index.toString(), index: index, isDragDisabled: props.disabled }, { children: function (provided, itemSnapshot) {
                            var _a;
                            return (_jsxs(ListItem, __assign({ onClick: function () { return props.onStepEditClick(index); }, ref: provided.innerRef }, provided.draggableProps, { style: getItemStyle(index, itemSnapshot.isDragging, provided.draggableProps.style) }, { children: [_jsx(ListItemIcon, __assign({ style: { minWidth: "32px" } }, { children: item.isMultiAttachment ? _jsx(CollectionsOutlinedIcon, { fontSize: "large" }, void 0) : _jsx(InsertPhotoOutlinedIcon, { fontSize: "large" }, void 0) }), void 0), _jsx(ListItemText, { primary: item.title, secondary: (_a = item.description) !== null && _a !== void 0 ? _a : " " }, void 0), _jsx(ListItemSecondaryAction, { children: renderActions(index, snapshot.isDraggingOver, __assign({}, provided.dragHandleProps), props.disabled) }, void 0)] }), void 0));
                        } }), index)); }), provided.placeholder] }), void 0)); } }), void 0) }), void 0));
}
